var _circle, _circle2, _g, _path, _g2, _g3, _path2, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoorSensorIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 63,
  height: 60,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#F5F5F5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#FF8080",
  className: "door-sensor-icon_svg__connection-status"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "gray",
  className: "door-sensor-icon_svg__no-status"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49 46 7 7M56 46l-7 7"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "door-sensor-icon_svg__a",
  width: 20,
  height: 20,
  x: 43,
  y: 17,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M43 17h20v20H43z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  className: "door-sensor-icon_svg__no-battery-status",
  mask: "url(#door-sensor-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M52.167 28.667h1.666v-5h-1.666zM53 32q.354 0 .594-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594T53 32m-3.333 3.334a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.594V21.167q0-.354.24-.594t.594-.24h1.666v-1.666h3.334v1.667h1.666q.354 0 .594.24.24.239.24.593V34.5q0 .354-.24.594a.8.8 0 0 1-.594.24zm.833-1.667h5V22h-5z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  fill: "#003252",
  clipPath: "url(#door-sensor-icon_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23.333 19A2.667 2.667 0 0 1 26 21.667v16a2.667 2.667 0 0 1-2.667 2.666H22a2.667 2.667 0 0 1-2.667-2.666v-16A2.667 2.667 0 0 1 22 19zM22 21a.667.667 0 0 0-.667.667v16c0 .368.299.666.667.666h1.333a.667.667 0 0 0 .667-.666v-16a.667.667 0 0 0-.667-.667zM38 19a2.667 2.667 0 0 1 2.667 2.667v16A2.667 2.667 0 0 1 38 40.333h-1.333A2.667 2.667 0 0 1 34 37.667v-16A2.667 2.667 0 0 1 36.667 19zm-1.333 2a.667.667 0 0 0-.667.667v16c0 .368.299.666.667.666H38a.667.667 0 0 0 .667-.666v-16A.667.667 0 0 0 38 21z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.524 26.398c.207-.145.537-.041.702.248a6.28 6.28 0 0 1 0 6.04c-.155.29-.485.394-.702.249s-.258-.455-.123-.704a5.35 5.35 0 0 0 0-5.14c-.135-.238-.093-.548.123-.703zm-.95 1.572c-.154-.33-.505-.465-.711-.31-.207.155-.248.455-.134.703a3.06 3.06 0 0 1 0 2.586c-.114.248-.073.548.134.703.206.155.557.02.712-.31a4.01 4.01 0 0 0 0-3.372"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "door-sensor-icon_svg__c",
  width: 20,
  height: 20,
  x: 43,
  y: 17,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M43 17h20v20H43z"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  className: "door-sensor-icon_svg__full-battery",
  mask: "url(#door-sensor-icon_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#14B814",
  d: "M49.833 35.667a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.594V21.5q0-.354.24-.594t.593-.24H51.5V19h3.333v1.667H56.5q.354 0 .594.24.24.239.24.593v13.333q0 .354-.24.594a.8.8 0 0 1-.594.24z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg",
  className: "door-sensor-icon_svg__low-battery",
  mask: "url(#door-sensor-icon_svg__mask1_951_12431)",
  transform: "translate(43 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8080",
  d: "M9.167 11.667h1.666v-5H9.167zM10 15q.354 0 .594-.24t.24-.594a.8.8 0 0 0-.24-.593.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.593q0 .355.24.594.24.24.594.24m-3.333 3.333a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.593V4.167q0-.356.24-.594.24-.24.594-.24h1.666V1.667h3.334v1.666h1.666q.354 0 .594.24t.24.594V17.5q0 .354-.24.594a.8.8 0 0 1-.594.24zm.833-1.666h5V5h-5z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  className: "door-sensor-icon_svg__medium-battery",
  mask: "url(#door-sensor-icon_svg__mask0_951_9234)",
  transform: "translate(43 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F9C030",
  d: "M6.667 18.333a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.593V4.167q0-.356.24-.594.24-.24.594-.24h1.666V1.667h3.334v1.666h1.666q.354 0 .594.24t.24.594V17.5q0 .354-.24.594a.8.8 0 0 1-.594.24zM7.5 15h5V5h-5z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "door-sensor-icon_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14 13.664h32v32H14z"
})))));
export default SvgDoorSensorIcon;